/** Responsável por mostrar quantas pastas foram filtradas em determinado período */
import React, { Component } from "react";

import api from "../../../../services/api";

import "./styles.css";

import { Col, Row } from "antd";

export default class StatsWidget extends Component {
  /**
   * Obtém estatísticas dos filtros
   * realizados pelo usuário, e a quantidade de pastas
   * restantes para serem filtradas.
   */
  state = {
    pastas_restantes: "...",
    filtradas_hoje: "...",
    filtradas_mes: "..."
  };

  async componentDidMount() {
    // Make api request
    try {
      let filtradas_hoje = await api.get("/filtro/relatorio/hoje/");
      filtradas_hoje = filtradas_hoje.data.result;

      let filtradas_mes = await api.get("/filtro/relatorio/mes/");
      filtradas_mes = filtradas_mes.data.result;

      let restantes = await api.get("/filtro/relatorio/restantes/");
      restantes = restantes.data.result;

      this.setState({
        pastas_restantes: restantes,
        filtradas_hoje: filtradas_hoje,
        filtradas_mes: filtradas_mes
      });
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return (
      <div className="stats__container">
        <div className="stats__subcontainer">
          <Row gutter={8}>
            <Col span={8}>
              Pastas restantes: <b>{this.state.pastas_restantes}</b>
            </Col>
            <Col span={8}>
              Filtradas hoje: <b>{this.state.filtradas_hoje}</b>
            </Col>
            <Col span={8}>
              Filtradas este mês: <b>{this.state.filtradas_mes}</b>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/StatsWidget/index.js